import { useState } from "react";
import PropTypes from "prop-types";
import SwitchMembershipSectionWrapper from "../section-wrapper";
import MembershipLabel from "./modules/membership-label";
import Filter from "common/components/responsive/filter";
import classNames from "classnames";
import toast from "common/utils/toast";
import { initMembershipPricings } from "admin/api/AuthApi";

const SwitchingFromToMemberships = ({
   isMobile,
   selectedMembershipToSwitch,
   onSelectMembership,
   switchingFromPricingsData,
}) => {
   const [publishedMemberships, setPublishedMemberships] = useState({
      isLoading: true,
      data: [],
   })

   const getPublishedMemberships = async () => {
      try {
         setPublishedMemberships({
            ...publishedMemberships,
            isLoading: true,
         })
         const { data } = await initMembershipPricings(['query[]=status=active']);
         setPublishedMemberships({
            isLoading: false,
            data: data,
         })
      } catch (error) {
         toast.error('Something went wrong')
      }
   }

   return (
      <SwitchMembershipSectionWrapper>
         <div
            className='w-full flex flex-col gap-2.5'
         >
            <div
               className='w-full flex flex-col gap-2'
            >
               <span
                  className='text-major font-medium leading-5'
               >
                  Switching from
               </span>
               <div
                  className='w-full flex gap-2 flex-wrap'
               >
                  {
                     switchingFromPricingsData.map(item => (
                        <MembershipLabel
                           key={ item.pricing_id }
                           name={ item.pricing_name }
                        />
                     ))
                  }
               </div>
            </div>
            <div
               className='w-full flex flex-col gap-2'
            >
               <span
                  className='text-major font-medium leading-5'
               >
                  To
               </span>
               <Filter
                  desktopType={ isMobile ? 'mobile' : 'desktop' }
                  filterClassName='w-full'
                  className='w-full'
                  height='10'
                  showNewStyles
                  activeSelectedValue={ !selectedMembershipToSwitch ? { name: 'Select membership to switch to' } : selectedMembershipToSwitch }
                  activeValueColor={ classNames({
                     '!w-[auto]': true,
                     'text-placeholder': !selectedMembershipToSwitch,
                  }) }
                  textWrapperClassName='justify-between !max-w-full'
                  contentStyles={ {
                     width: '100%',
                     right: 0,
                     top: '44px',
                  } }
                  onOpenFilter={ (isOpen) => {
                     if(isOpen && !publishedMemberships.data.length) {
                        getPublishedMemberships()
                     }
                  } }
                  data={ publishedMemberships.data }
                  isLoadinngData={ publishedMemberships.isLoading }
                  isSearchable={ !publishedMemberships.isLoading }
                  filterValueKey='id'
                  onFilterChange={ (value, name) => {
                     onSelectMembership({
                        name: name,
                        id: value,
                        value: value,
                     })
                  } }
                  version='v1'
                  viewClassName='!w-full'
                  radioClassName='!h-10 py-0'
                  contentClassName='max-h-[200px]'
                  showClearButton={ false }
                  overrideValueNameProps={ {
                     textClass: 'text-major font-normal',
                     width: '100%',
                     fontWeight: '400',
                     textSize: '16px',
                  } }
                  loaderColor='secondary'
                  arrowIconClassName={ !selectedMembershipToSwitch ? '!text-placeholder' : '!text-secondary' }
                  scrollIntoViewOnOpenContent
               />
            </div>

         </div>
      </SwitchMembershipSectionWrapper>
   )
}

SwitchingFromToMemberships.propTypes = {
   switchingFromPricingsData: PropTypes.array,
   isMobile: PropTypes.bool,
   selectedMembershipToSwitch: PropTypes.object,
   onSelectMembership: PropTypes.func,
}

export default SwitchingFromToMemberships;
